export function set(cart){
    
    return { type: 'CART/SET', cart }
}

export function clear(){
    return { type: 'CART/SET', cart: [] }
}

export function open(){
    return { type: 'IS_CART_OPEN/SET', isCartOpen: true }
}

export function close(){
    return { type: 'IS_CART_OPEN/SET', isCartOpen: false }
}

export function removeItem(id){
    return { type: 'CART/REMOVE/ITEM', id }
}

export function clearLeagueCart(idLeague){
    return { type: 'CART/REMOVE/LEAGUE', idLeague }
}